import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { USE_THETRARIS_LOGO } from '../../../../shared/env';
import {
  Agreement as AgreementType,
  agreements,
} from '../../../../shared/utils/agreement';
import { BlueRoundedButtonWithIcon } from '../../common/components/BlueRoundedButton';
import { Spacer } from '../../common/components/Spacer';
import {
  SectionContentContainer,
  SectionHeading,
} from '../../common/components/styledComponents';

import { DeleteAccountModal } from './DeleteAccountModal';

const AgreementContainer = styled.div`
  box-sizing: border-box;
  width: inherit;
  max-height: 286px;
  padding: 10px;
  background-color: #d9d9d9;
  text-align: inherit;
  overflow-y: auto;
`;

const AgreementTitle = styled.span`
  align-self: flex-start;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #000000;
`;

export interface AgreementProps {
  type: AgreementType;
}
export const Agreement = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.agreement',
  });

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <SectionContentContainer>
        <SectionHeading>{t('heading')}</SectionHeading>
        <Spacer height="41px" />
        <AgreementTitle id="termsOfService">
          {t('termsOfService')}
        </AgreementTitle>
        <AgreementContainer
          dangerouslySetInnerHTML={{
            __html: USE_THETRARIS_LOGO
              ? agreements.termsOfServiceEn
              : agreements.termsOfServiceV2,
          }}
        />
        <Spacer height="24px" />
        <AgreementTitle id="personalInformation">
          {t('personalInformation')}
        </AgreementTitle>
        <AgreementContainer
          dangerouslySetInnerHTML={{
            __html: USE_THETRARIS_LOGO
              ? agreements.personalInformationEn
              : agreements.personalInformationV2,
          }}
        />
        <BlueRoundedButtonWithIcon
          marginTop="120px"
          maxWidth="181px"
          onClick={() => setOpenModal(true)}>
          {t('button')}
        </BlueRoundedButtonWithIcon>
      </SectionContentContainer>
      <DeleteAccountModal
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
};
